import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import es from "./locales/es.json";
import en from "./locales/en.json";

// Configuración base
i18n
  .use(initReactI18next) // conecta con React
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: "es", // idioma inicial
    fallbackLng: "es", // si falta algo en el idioma actual, usa español
    interpolation: {
      escapeValue: false, // react ya hace el escape por seguridad
    },
  });

export default i18n;
